module.exports = __webpack_public_path__ + "static/media/bayonetta_0.d7099633.png";